import moment from 'moment-timezone'

export const createTimelineDateRange = timezone => {
    const today = moment.tz(timezone)

    return {
        opens: 'right',
        sampleLocaleData: {},
        range: {
            startDate: today.clone().startOf('day').toDate(),
            endDate: today.clone().endOf('day').toDate(),
        },
        maxDate: today.clone().endOf('day').toDate(),
    }
}

export const clampTimelineRange = (startValue, endValue, timezone, maximumDays = 30) => {
    let startDate = moment(startValue).tz(timezone)
    let endDate = moment(endValue).tz(timezone)
    const maxDate = moment().tz(timezone).endOf('day')

    if (endDate.isAfter(maxDate)) endDate = maxDate

    const wasClamped = endDate.diff(startDate, 'days') > maximumDays
    if (wasClamped) startDate = endDate.clone().subtract(maximumDays, 'days')

    return { startDate, endDate, wasClamped }
}

export const parseTimelineFilterParams = value => {
    if (!value) return null

    try {
        const parsed = typeof value === 'string' ? JSON.parse(value) : value
        if (!parsed || Array.isArray(parsed) || typeof parsed !== 'object') return null

        const hasValidRange = moment(parsed.startDate, moment.ISO_8601, true).isValid() && moment(parsed.endDate, moment.ISO_8601, true).isValid()
        if (!hasValidRange) return null

        return parsed
    } catch (_error) {
        return null
    }
}

export const cleanTimelineRow = row => {
    if (!row) return null
    const data = JSON.parse(JSON.stringify(row))
    delete data.vgt_id
    delete data.originalIndex
    return data
}

const readTotalCount = value => {
    if (Array.isArray(value)) return value[0]?.count || 0
    return value ?? 0
}

export const normalizeTimelinePage = (response, filters = {}) => {
    const body = response?.data || response || {}
    const rawResults = Array.isArray(body.results) ? body.results : []

    if (rawResults.length === 1 && Array.isArray(rawResults[0]?.paginatedResults)) {
        const aggregate = rawResults[0]
        return {
            results: aggregate.paginatedResults,
            totalCount: readTotalCount(aggregate.totalCount),
            page: body.page ?? filters.skip ?? 1,
            limit: body.limit ?? filters.limit ?? aggregate.paginatedResults.length,
        }
    }

    return {
        results: rawResults,
        totalCount: body.totalCount ?? body.total ?? rawResults.length,
        page: body.page ?? filters.skip ?? 1,
        limit: body.limit ?? filters.limit ?? rawResults.length,
    }
}

export const normalizeTimelinePatrolActions = actions => {
    return (actions || []).map(action => ({
        ...action,
        medias: {
            photo: action?.photoURL || null,
            signature: action?.signatureURL || null,
            sound: action?.soundURL || null,
        },
    }))
}
